import { render, staticRenderFns } from "./HomeSecond.vue?vue&type=template&id=37cf2c12&scoped=true&"
import script from "./HomeSecond.vue?vue&type=script&lang=js&"
export * from "./HomeSecond.vue?vue&type=script&lang=js&"
import style0 from "./HomeSecond.vue?vue&type=style&index=0&id=37cf2c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf2c12",
  null
  
)

export default component.exports